// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // Import getFirestore function
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBLHFtYQ_uuM2Z9wZBYbH6_nAHWL6Ofyfw",
  authDomain: "look4partner-e0e8c.firebaseapp.com",
  projectId: "look4partner-e0e8c",
  storageBucket: "look4partner-e0e8c.firebasestorage.app",
  messagingSenderId: "912414665810",
  appId: "1:912414665810:web:c381b02b014fbbd55fc38b",
  measurementId: "G-7T13CL1J8C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

export const storage = getStorage(app);

// Export db
export { db };
export const auth = getAuth(app); 